import { useMemo } from "react";
import { cacheService } from "../../../Core/Api/services";
import { useLocation, useNavigate } from "react-router";
import { useAppSelector } from "../../../Redux/redux-store";
import {
  GetCurrentObj,
  GetFilterText,
  GetLayout,
  GetLoadingStates,
  GetObjectResults,
} from "../../../Redux/Reducers/redux-slice-drive";
import { GetTreeObj, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import { CircularProgress, Stack } from "@mui/material";
import { PlatformMode } from "../../../Core/Api/Types/platform-mode";
import { DriveAssetGrid } from "../Common/drive-asset-grid";
import DropFilesWrapper from "../Common/drive-drop-files-wrapper";
import { IsPermissionGranted } from "../../../Core/Utils/asset-object-utils";
import { PermissionType } from "../../../Core/Api/Types/permission-type";
import { useTranslation } from "react-i18next";
import { DriveAssetTable } from "../Common/drive-asset-table";
import { useFolderPagination } from "../helpers/use-drive-pagination";

export const DriveFolderContent = () => {
  // Local props & states
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Redux
  const { folderLoading } = useAppSelector(GetLoadingStates);
  const resultObjects = useAppSelector(GetObjectResults);
  const layout = useAppSelector(GetLayout);
  const treeObj = useAppSelector(GetTreeObj(TreeContext.DriveTreeview));
  const currentObject = useAppSelector(GetCurrentObj);
  const { loadFolderContents } = useFolderPagination();

  // Cache
  const platformMode = cacheService.GetPlatformMode();

  const userCanUploadFiles = useMemo(() => {
    if (!treeObj) return false;

    return IsPermissionGranted(treeObj, PermissionType.CreateObject);
  }, [treeObj]);

  return (
    <>
      {folderLoading || (!resultObjects && platformMode !== PlatformMode.Adam) ? (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "48%",
            left: "45%",
          }}
          size={48}
        />
      ) : (
        <Stack
          sx={(theme) => ({
            flex: "1 1 0",
            minHeight: 0,
            width: "100%",
          })}
        >
          <DropFilesWrapper currentAsset={currentObject} userCanUploadFiles={userCanUploadFiles}>
            <>
              {layout === "grid" && <DriveAssetGrid resultObjects={resultObjects} loadContents={loadFolderContents} />}
              {layout === "list" && (
                <Stack px={2} width="100%" height="100%">
                  <DriveAssetTable resultObjects={resultObjects} loadContents={loadFolderContents} />
                </Stack>
              )}
            </>
          </DropFilesWrapper>
        </Stack>
      )}
    </>
  );
};
